import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WebComponent } from './template/layouts/web/web.component';
import { MotoresComponent } from './template/layouts/motores/motores.component';

export const APP_ROUTES: Routes = [
    {
        path: 'motor',
        component: MotoresComponent,
        data: { title: 'motor views' },
        children: [
            {
                path: '',
                loadChildren: './modules/motores/motores.module#MotoresModule'
            }
        ]
    },
    {
        path: '',
        component: WebComponent,
        data: { title: 'web views' },
        children: [
            {
                path: '',
                loadChildren: './modules/web/web.module#WebModule'
            }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(APP_ROUTES, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
